import { MutableRecordStore } from '@deqo/foundation';

const template = {
    data: [],
    until: 0,
};

export class Annotation extends MutableRecordStore(template) {

    public static readonly ttl = 5000;

    public readonly type = 'annotation';
    public readonly sort = Date.now();

    constructor(
        public readonly id: string,
        public readonly group: string,
        public readonly color: string) {
        super();
    }
}
